var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded)?_c('line-chart',{attrs:{"chart-data":_vm.datacollection,"height":110}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }